<template>
  <footer class="footer px-4 py-6">
    <div class="footer-content">
      <p class="text-sm text-gray-600 text-center">Powered by <a class="text-blue-700" href="https://twitter.com/iaminos">CAST.</a></p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'ListViewFooter',
}
</script>

<style scoped>

</style>
